interface Props {
  pessoaFisicaId: number;
}

const FotoMembro: React.FC<Props> = ({ pessoaFisicaId }: Props): React.ReactElement => {
  return (
    <img
      loading="lazy"
      style={{ width: '60px', height: '75px' }}
      alt="Foto"
      src={`https://mpvirtual.mppb.mp.br/FotoServlet?pfid=${pessoaFisicaId}`}
    />
  );
};

export default FotoMembro;
